import React from "react"

export function Stat({
  label,
  value,
  valueClassName = "",
  hint,
  term = false,
  className = "",
  children,
}) {
  const LabelTag = term ? "dt" : "p"
  const ValueTag = term ? "dd" : "p"
  const valueClasses = ["ui-stat__value", valueClassName].filter(Boolean).join(" ")

  return (
    <div className={["ui-stat", className].filter(Boolean).join(" ")}>
      {label != null && <LabelTag className="ui-stat__label">{label}</LabelTag>}
      {value != null && <ValueTag className={valueClasses}>{value}</ValueTag>}
      {hint ? <p className="mt-1 text-xs text-muted">{hint}</p> : null}
      {children}
    </div>
  )
}

export default Stat
